import React from 'react';
import api from 'api';
import moment from 'moment';
import IbeCalendar from '../components/IbeCalendar';

class IbeCalendarContainer extends React.Component {
  constructor(props) {
    super(props);
    this.initialized = false;
    this.handleChangeDate = this.handleChangeDate.bind(this);
    this.handleSelectProperty = this.handleSelectProperty.bind(this);
  }
  componentDidMount() {
    this.props.api.property.getObjects({
      queryOptions: [['id', 'name'], { order: { name: 'asc' } }],
    });
    const today = moment();
    this.props.api.property.setData({
      selectedYear: today.year(),
      selectedMonth: today.month(),
      selectedDay: today.date(),
    });
    this.initialized = true;
  }
  componentWillUnmount() {
    this.props.api.property.setData({ selectedPropertyId: null, ibeCalendar: null });
  }
  render() {
    if (!this.initialized) return null;
    const { selectedYear, selectedMonth, selectedDay } = this.props;
    const calendarDates = this.getListDates({ year: selectedYear, month: selectedMonth, day: selectedDay });
    const from = calendarDates[0].stringISO;
    const to = calendarDates.slice(-1)[0].stringISO;
    return (
      <IbeCalendar
        onSelectProperty={ this.handleSelectProperty }
        calendarDates={ calendarDates }
        onChangeDate={ this.handleChangeDate }
        conditions={ this.getConditions(this.props.ibeCalendar, { from, to }) }
        prices={ this.getPrices(this.props.ibeCalendar, { from, to }) }
        { ...this.props } />
    );
  }

  getListDates({ year, month, day }) {
    const date = moment({ year, month, day });
    const isMonday = date.isoWeekday() === 1;
    const start = isMonday ? date.subtract(7, 'days') : date.startOf('isoWeek');
    const end = start.clone().add(41, 'days');
    const listDates = [];
    for (let currentDate = start; currentDate.isSameOrBefore(end); currentDate.add(1, 'days')) {
      const currentDay = this.getListDays()[currentDate.isoWeekday() - 1];
      const dateParams = { stringISO: currentDate.format('YYYY-MM-DD'), label: `${currentDay.short} ${currentDate.format('DD')}` };
      listDates.push(dateParams);
    }
    return listDates;
  }
  getListDays() {
    return [
      { name: 'Monday', short: 'Mo', value: 1 },
      { name: 'Tuesday', short: 'Tu', value: 2 },
      { name: 'Wednesday', short: 'We', value: 3 },
      { name: 'Thursday', short: 'Th', value: 4 },
      { name: 'Friday', short: 'Fr', value: 5 },
      { name: 'Saturday', short: 'Sa', value: 6 },
      { name: 'Sunday', short: 'Su', value: 7 },
    ];
  }
  handleChangeDate({ year, month, day }) {
    this.props.api.property.setData({
      selectedYear: year,
      selectedMonth: month,
      selectedDay: day,
    });
  }

  handleSelectProperty({ value }) {
    this.props.api.property.setData({ selectedPropertyId: value });
    // const val = '709240322479362048';
    this.props.api.property.getData({
      url: `/${value}/ibe-calendar`,
      propName: 'ibeCalendar'
    });
  }
  getConditions(ibeCalendar, { from, to }) {
    if (!ibeCalendar) return [];
    const conditions = [];
    for (let currentDay = from; currentDay <= to; currentDay = moment(currentDay).add(1, 'days').format('YYYY-MM-DD')) {
      const condition = ibeCalendar.conditions.find(c => c.date === currentDay) || {};
      conditions.push({ date: currentDay, display_type: 'base', min_stay: condition.min_stay });
    }
    return conditions;
  }
  getPrices(ibeCalendar, { from, to }) {
    if (!ibeCalendar) return [];
    // 'key' is minNights_nbPeople
    const prices = Object.keys(ibeCalendar.prices).reduce((result, key) => {
      const pricesByDay = {};
      Object.keys(ibeCalendar.prices[key]).forEach(day => {
        if (day >= from && day <= to) pricesByDay[day] = { ...ibeCalendar.prices[key][day], display_type: 'base' };
      });
      return { ...result, [key]: pricesByDay };
    }, {});
    return prices;
  }
}

export default api.connect(IbeCalendarContainer, 'property');



// WEBPACK FOOTER //
// ./src/frontend/modules/inventory/property/containers/IbeCalendar.jsx